import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import QueryManagementEmailTemplates from 'graphql/queries/management/QueryManagementEmailTemplates'

const FetchManagementEmails = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null, employeeCount = true, variables = {} } = {} ) => {
		new GraphqlBuilder()
			.addQuery( 'email_templates', QueryManagementEmailTemplates, variables )
			.setResultPath( ['email_templates', 'email_templates'], [] )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( result );
				}
			})
			.execute()
	}
}

export default FetchManagementEmails
